import { render, staticRenderFns } from "./GovernanceRelevantBizFoundInfoList.vue?vue&type=template&id=4c0d3d0a&scoped=true&"
import script from "./GovernanceRelevantBizFoundInfoList.vue?vue&type=script&lang=js&"
export * from "./GovernanceRelevantBizFoundInfoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0d3d0a",
  null
  
)

export default component.exports